// src/documents/closingPdf.js
//
// Closing Statement (2 páginas): se escriben los datos sobre la plantilla del
// cliente src/assets/documents/closing-template.pdf, que ya trae el membrete,
// los rótulos y las rayas (mapa de campos en closingTemplate.js). Antes se
// dibujaba desde cero con un marcador de "membrete pendiente".
//
// `templateBytes` es opcional: en el navegador se descarga la plantilla
// empaquetada; las pruebas (Node) la pasan leída del disco.
import closingTemplateUrl from '../assets/documents/closing-template.pdf';
import { fillPdf } from './pdfFill';
import { CLOSING_TEMPLATE } from './closingTemplate';

export const generateClosingPdf = async (values, { templateBytes } = {}) => {
  const bytes = templateBytes || new Uint8Array(await (await fetch(closingTemplateUrl)).arrayBuffer());
  return fillPdf(bytes, CLOSING_TEMPLATE, values);
};
